<template>
  <div class="order-container" v-if="refresh">
    <!--<div class="hd research-background-color">-->
      <!--<span class="icon icon-left navshare" @click="goBack"></span>-->
      <!--<span class="header_title">课题组订单</span>-->
    <!--</div>-->

    <div class="bd">
      <gc-order-search-box
        @updateSearchMap="handleFilter"></gc-order-search-box>
      <div class="tab-group">
        <span  class="order-status" @click="changeTab(emkt.MYORDER_TAB_WAITAUDIT)" :lines="undefined" :class="[tabIndex===emkt.MYORDER_TAB_WAITAUDIT?'colorBlack': 'colorGrey']">待审核</span>
        <span v-if="!isAfterSales" class="order-status" @click="changeTab(emkt.MYORDER_TAB_WAITPAY)" :lines="undefined" :class="[tabIndex===emkt.MYORDER_TAB_WAITPAY?'colorBlack': 'colorGrey']">待下单</span>
        <span class="order-status" @click="changeTab(emkt.MYORDER_TAB_EXECUTE)" :lines="undefined" :class="[tabIndex===emkt.MYORDER_TAB_EXECUTE?'colorBlack': 'colorGrey']">执行中</span>
        <span class="order-status" @click="changeTab(emkt.MYORDER_TAB_FINISHED)" :lines="undefined" :class="[tabIndex===emkt.MYORDER_TAB_FINISHED?'colorBlack': 'colorGrey']">已完成</span>
        <span v-if="!isAfterSales" class="order-status" @click="changeTab(emkt.MYORDER_TAB_CANCELLED)" :lines="undefined" :class="[tabIndex===emkt.MYORDER_TAB_CANCELLED? 'colorBlack': 'colorGrey']">已取消</span>
      </div>
      <div class="tab-line-group">
        <div class="under-line" :style="{'visibility': tabIndex===emkt.MYORDER_TAB_WAITAUDIT? 'visible':'hidden'}"/>
        <div v-if="!isAfterSales" class="under-line" :style="{'visibility': tabIndex===emkt.MYORDER_TAB_WAITPAY? 'visible':'hidden'}"/>
        <div class="under-line" :style="{'visibility': tabIndex===emkt.MYORDER_TAB_EXECUTE? 'visible':'hidden'}"/>
        <div class="under-line" :style="{'visibility': tabIndex===emkt.MYORDER_TAB_FINISHED? 'visible':'hidden'}"/>
        <div v-if="!isAfterSales" class="under-line" :style="{'visibility': tabIndex===emkt.MYORDER_TAB_CANCELLED? 'visible':'hidden'}"/>
      </div>
    </div>
    <div class="box" id="myOrderList">
      <div class="order-list" v-show="hasCurrentDisplayOrders">
        <div  v-show="tabIndex===emkt.MYORDER_TAB_WAITAUDIT">
          <order-list :orderList="displayWaitAduitOrders"></order-list>
        </div>
        <div v-show="tabIndex===emkt.MYORDER_TAB_WAITPAY">
          <order-list :orderList="displayWaitPayOrders" @cancelOrder="handleOrderCancel"
                      @submitOrderToSign="handleOrderToSign"
                      @submitOrderToCheckSignApprove="handleOrderToCheckSignApprove"
                      @submitOrder="handleOrderSubmit"></order-list>
        </div>
        <div v-show="tabIndex===emkt.MYORDER_TAB_EXECUTE">
          <order-list :orderList="displayExecutedOrders" @cancelOrder="handleOrderCancel"></order-list>
        </div>
        <div v-show="tabIndex===emkt.MYORDER_TAB_FINISHED">
          <order-list :orderList="displayFinishedOrders"></order-list>
        </div>
        <div v-show="tabIndex===emkt.MYORDER_TAB_CANCELLED">
          <order-list :orderList="displayCancledOrders"></order-list>
        </div>
        <div class="research-font-color" style="text-align: center; height: 100px;" v-if="fetchOrdersCompleted">
          <span @click="loadMoreCurrentTabDisplayOrders" v-if="showLoadMore">加载更多...</span>
          <p style="font-size: 12px; margin-bottom: 30%;" v-else>---我是有底线的---</p>
        </div>
      </div>
      <img v-show="fetchOrdersCompleted && !hasCurrentDisplayOrders" src="/static/img/订单空.png" style="width: 100%;">
    </div>
  </div>
</template>

<script>
  import OrderList from './OrderListPage.vue'
  // import $ from 'jquery'
  import wx from 'wx'
  import { getOrdersByCustomerOrResearchNo } from '@/emktcommon/api/orderApi.js'

  import {mapGetters, mapState, mapMutations} from 'vuex'
  import EMKT from '../../../emkt'
  import GcOrderSearchBox from '../../../emktcommon/orders/order/components/GcOrderSearchBox.vue'
  export default {
    components: {
      OrderList, GcOrderSearchBox
    },
    watch: {
      'customerNo': {
        handler: 'fetchOrders',
        immediate: true
      },
      'tabIndex': {
        handler: 'setCurrentTabIndex'
      },
      '$route.query.afterSales': {
        handler: 'fetchOrders',
        immediate: true
      }
    },
    data () {
      return {
        refresh: true,
        tabIndex: EMKT.MYORDER_TAB_EXECUTE,
        orderObject: {},
        displayWaitPayOrders: [],
        displayExecutedOrders: [],
        displayFinishedOrders: [],
        displayCancledOrders: [],
        countOfLoadingMoreOrders: 10,
        fetchOrdersCompleted: false,
        memberList: ['李红日', '白牡蛎', '大河二', '白牡蛎', '大河二'],
        searchMap: {},
        displayWaitAduitOrders: []
      }
    },
    mounted () {
      // this.fetchOrders()
      // console.log('Orders mounted')
    },
    activated () {
      if (this.currentMyOrderTabIndex !== -1) {
        this.tabIndex = this.currentMyOrderTabIndex
      } else if (EMKT.getUrlParamHref('orderTabIndex')) {
        this.tabIndex = Number(EMKT.getUrlParamHref('orderTabIndex')) > 5 ? EMKT.MYORDER_TAB_WAITPAY : Number(EMKT.getUrlParamHref('orderTabIndex'))
      } else {
        this.tabIndex = EMKT.MYORDER_TAB_WAITPAY
      }
      // 若在订单详情页面取消订单，需要更新用来显示的待下单订单和已取消订单
      const cancelled = EMKT.getLocalStorage('cancelledOrder')
      console.log('cancelled order', cancelled)
      if (cancelled) {
        this.updateMyOrders(cancelled)
        EMKT.setStoreItem('cancelledOrder', null)
      }
      console.log('Orders activated, getUrlParamHref= ', Number(EMKT.getUrlParamHref('orderTabIndex')), 'this.currentMyOrderTabIndex=', this.currentMyOrderTabIndex)
      // 修改订单地址
      // let addressOrder = EMKT.getLocalStorage('addressOrder')
      // if (addressOrder) {
      //   this.updateMyAllOrders(addressOrder)
      //   EMKT.setStoreItem('addressOrder', null)
      // }
      this.goToLeavePosition()
    },
    computed: {
      ...mapState([
        'currentMyOrderTabIndex', 'weappMyOrders', 'sessionInfo'
      ]),
      ...mapGetters([
        'customerNo'
      ]),
      myWaitPayOrders () {
        return this.orderObject.waitPayOrderList || []
      },
      myExecutedOrders () {
        return this.orderObject.executedOrderList || []
      },
      myFinishedOrders () {
        return this.orderObject.finishedOrderList || []
      },
      myCancledOrders () {
        return this.orderObject.cancledOrderList || []
      },
      myWaitAuditOrderList () {
        return this.orderObject.waitAuditOrderList || []
      },
      showLoadMore () {
        let ifShowBtn = false
        if (this.keywordSearchOnGoing) return false
        switch (this.tabIndex) {
          case EMKT.MYORDER_TAB_WAITPAY:
            ifShowBtn = this.displayWaitPayOrders.length < this.myWaitPayOrders.length
            break
          case EMKT.MYORDER_TAB_EXECUTE:
            ifShowBtn = this.displayExecutedOrders.length < this.myExecutedOrders.length
            break
          case EMKT.MYORDER_TAB_WAITAUDIT:
            ifShowBtn = this.displayWaitAduitOrders.length < this.myWaitAuditOrderList.length
            break
          case EMKT.MYORDER_TAB_FINISHED:
            ifShowBtn = this.displayFinishedOrders.length < this.myFinishedOrders.length
            break
          case EMKT.MYORDER_TAB_CANCELLED:
            ifShowBtn = this.displayCancledOrders.length < this.myCancledOrders.length
            break
        }
        return ifShowBtn
      },
      hasCurrentDisplayOrders () {
        let hasOrders = false
        switch (this.tabIndex) {
          case EMKT.MYORDER_TAB_WAITPAY:
            hasOrders = this.displayWaitPayOrders.length > 0
            break
          case EMKT.MYORDER_TAB_EXECUTE:
            hasOrders = this.displayExecutedOrders.length > 0
            break
          case EMKT.MYORDER_TAB_FINISHED:
            hasOrders = this.displayFinishedOrders.length > 0
            break
          case EMKT.MYORDER_TAB_WAITAUDIT:
            hasOrders = this.displayWaitAduitOrders.length > 0
            break
          case EMKT.MYORDER_TAB_CANCELLED:
            hasOrders = this.displayCancledOrders.length > 0
            break
        }
        return hasOrders
      },
      keywordSearchOnGoing () {
        return this.searchMap && this.searchMap.keyword
      },
      isAfterSales () {
        return !!this.$route.query.afterSales
      }
    },
    methods: {
      ...mapMutations([
        'SET_CURRENT_MYORDER_TABINDEX', 'UPDATE_WEAPP_MYORDERS', 'SET_CURRENT_WAITPAY_ORDER'
      ]),
      updateDisplayOrderList (list) {
        this.displayExecutedOrders = list || EMKT.filterOrderListBySearchMap(this.myExecutedOrders, this.searchMap)
        this.displayFinishedOrders = list || EMKT.filterOrderListBySearchMap(this.myFinishedOrders, this.searchMap)
        this.displayCancledOrders = list || EMKT.filterOrderListBySearchMap(this.myCancledOrders, this.searchMap)
        this.displayWaitPayOrders = list || EMKT.filterOrderListBySearchMap(this.myWaitPayOrders, this.searchMap)
        this.displayWaitAduitOrders = list || EMKT.filterOrderListBySearchMap(this.myWaitAuditOrderList, this.searchMap)
      },
      handleFilter (map) {
        this.searchMap = map
        if (this.keywordSearchOnGoing) {
          this.updateDisplayOrderList()
        } else {
          this.updateDisplayOrderList([])
          this.loadMoreCurrentTabDisplayOrders()
        }
        console.log('updateSearchMap', map)
      },
      setCurrentTabIndex () {
        if (!this.tabIndex) return
        this.returnToTopPosition()
        this.SET_CURRENT_MYORDER_TABINDEX(this.tabIndex)
        if (!this.keywordSearchOnGoing) {
          this.updateDisplayOrderList([])
          this.loadMoreCurrentTabDisplayOrders()
        }
      },
      async fetchOrders () {
        if (!this.customerNo) return
        this.$weui.loading('获取订单中')
        this.UPDATE_WEAPP_MYORDERS({})
        // test: getCustomerOrders type=2 no=00018007，00377256，00398575，00224169，00243640
        // 1.研转通 参数：type=4 and settlementAccountNo, 是本人
        // 执行中、已完成：根据结算账户取订单
        // 待下单、已取消：根据客户编号取订单
        // 2. gcrmg type = 2 CUSTOMER
        const paramType = this.$route.query.type || EMKT.QUERY_ORDER_TYPE.CUSTOMER
        const paramNo = Number(paramType) === EMKT.QUERY_ORDER_TYPE.CUSTOMER ? this.customerNo : EMKT.getUrlParam('settlementAccountNo')
        await getOrdersByCustomerOrResearchNo({type: paramType, no: paramNo, afterSales: this.$route.query.afterSales}).then(async res => {
          this.$weui.loading().hide()
          if (res) {
            this.orderObject = res
            this.UPDATE_WEAPP_MYORDERS(this.orderObject)
            // console.log('getAllOrdersByCustomerNoOrResearchGroupNo', this.orderObject, 'this.tabIndex=', this.tabIndex)
            // this.goToLeavePosition()
            // this.getServiceOrder()
            // this.loadMoreCurrentTabDisplayOrders()
            // this.fetchOrdersCompleted = true
          }
          if (Number(paramType) === EMKT.QUERY_ORDER_TYPE.SETTLEMENT_ACCOUNT) {
            this.$weui.loading('获取订单中')
            await getOrdersByCustomerOrResearchNo({
              type: EMKT.QUERY_ORDER_TYPE.CUSTOMER,
              no: this.customerNo,
              afterSales: this.$route.query.afterSales
            }).then(res => {
              this.$weui.loading().hide()
              if (res) {
                this.orderObject = {
                  ...this.orderObject,
                  waitPayOrderList: res.waitPayOrderList,
                  cancledOrderList: res.cancledOrderList
                }
                this.UPDATE_WEAPP_MYORDERS(this.orderObject)
                this.goToLeavePosition()
                this.getServiceOrder()
                this.loadMoreCurrentTabDisplayOrders()
                this.fetchOrdersCompleted = true
              }
            })
          } else {
            console.log('getAllOrdersByCustomerNoOrResearchGroupNo', this.orderObject, 'this.tabIndex=', this.tabIndex)
            this.goToLeavePosition()
            this.getServiceOrder()
            this.loadMoreCurrentTabDisplayOrders()
            this.fetchOrdersCompleted = true
          }
        })
      },
      loadMoreCurrentTabDisplayOrders () {
        let startIndex = 0
        let endIndex = 0
        let expectEndIndex = 0
        switch (this.tabIndex) {
          case EMKT.MYORDER_TAB_WAITPAY:
            startIndex = this.displayWaitPayOrders.length
            expectEndIndex = this.displayWaitPayOrders.length + this.countOfLoadingMoreOrders
            endIndex = (expectEndIndex > this.myWaitPayOrders.length ? this.myWaitPayOrders.length : expectEndIndex)
            this.displayWaitPayOrders.push(...this.myWaitPayOrders.slice(startIndex, endIndex))
            break
          case EMKT.MYORDER_TAB_EXECUTE:
            startIndex = this.displayExecutedOrders.length
            expectEndIndex = this.displayExecutedOrders.length + this.countOfLoadingMoreOrders
            endIndex = (expectEndIndex > this.myExecutedOrders.length ? this.myExecutedOrders.length : expectEndIndex)
            this.displayExecutedOrders.push(...this.myExecutedOrders.slice(startIndex, endIndex))
            break
          case EMKT.MYORDER_TAB_WAITAUDIT:
            startIndex = this.displayWaitAduitOrders.length
            expectEndIndex = this.displayWaitAduitOrders.length + this.countOfLoadingMoreOrders
            endIndex = (expectEndIndex > this.myWaitAuditOrderList.length ? this.myWaitAuditOrderList.length : expectEndIndex)
            this.displayWaitAduitOrders.push(...this.myWaitAuditOrderList.slice(startIndex, endIndex))
            break
          case EMKT.MYORDER_TAB_FINISHED:
            startIndex = this.displayFinishedOrders.length
            expectEndIndex = this.displayFinishedOrders.length + this.countOfLoadingMoreOrders
            endIndex = (expectEndIndex > this.myFinishedOrders.length ? this.myFinishedOrders.length : expectEndIndex)
            this.displayFinishedOrders.push(...this.myFinishedOrders.slice(startIndex, endIndex))
            break
          case EMKT.MYORDER_TAB_CANCELLED:
            startIndex = this.displayCancledOrders.length
            expectEndIndex = this.displayCancledOrders.length + this.countOfLoadingMoreOrders
            endIndex = (expectEndIndex > this.myCancledOrders.length ? this.myCancledOrders.length : expectEndIndex)
            this.displayCancledOrders.push(...this.myCancledOrders.slice(startIndex, endIndex))
            break
        }
      },
      getServiceOrder () {
        const excutedList = this.orderObject.waitPayOrderList
        let findout = excutedList.find(order => {
          order.itemList.map(item => item.contractNo).includes('GSGC0201795')
        })
        console.log('GSGC0201795', findout)
      },
      goToLeavePosition () {
        // 从订单详情返回到离开订单列表时的位置
        this.$nextTick(() => {
          let position = EMKT.getLocalStorage('leaveOrderListPosition')
          console.log('leaveOrderListPosition', position)
          if (position === null || position === undefined || !document.getElementById('myOrderList')) return
          document.getElementById('myOrderList').scrollTo(0, position)
        })
      },
      returnToTopPosition () {
        this.$nextTick(() => {
          console.log('returnToTopPosition')
          if (!document.getElementById('myOrderList')) return
          document.getElementById('myOrderList').scrollTo(0, 0)
        })
      },
      changeTab: function (index) {
        this.tabIndex = index
      },
      cancelOrder (order) {
        if (!order) return
        let orderId = order.id
        if (!orderId) {
          return this.$weui.topTips('当前订单缺少订单编号')
          // return $.toast('当前订单缺少订单编号')
        }
        if (order.status > EMKT.ORDER_STATUS_PAIED && order.status < EMKT.ORDER_STATUS_FINISHED) {
          return alert('订单已开始生产，无法自行取消，如有疑问请联系客服人员', {
            buttons: [{
              label: '我知道了'
            }]
          })
        }
        this.$weui.loading('正在取消订单')
        // $.showPreloader('正在取消订单')
        // this.updateMyOrders(order)
        this.gcapi('orderCancel', {id: orderId}).then(data => {
          // $.hidePreloader()
          this.$weui.loading().hide()
          this.updateMyOrders(order)
          this.$weui.toast('取消成功', 1500)
          // $.toast('取消成功')
        })
      },
      updateMyAllOrders (order) {
        const myOrders = this.weappMyOrders
        let index
        let index1
        // 待提交订单
        if (order.status <= EMKT.ORDER_STATUS_SUBMITTED ||
            order.status === EMKT.ORDER_STATUS_CHECK ||
            order.status === EMKT.ORDER_STATUS_WAIT_PD_TECH_AUDIT ||
            order.status === EMKT.ORDER_STATUS_SIGN_NEED) {
          for (let i = 0; i < myOrders.waitPayOrderList.length; i++) {
            if (myOrders.waitPayOrderList[i].orderNo === order.orderNo) {
              index = i
              break
            }
          }
          if (index >= 0) {
            myOrders.waitPayOrderList.splice(index, 1, order)
          }
          for (let i = 0; i < this.displayWaitPayOrders.length; i++) {
            if (this.displayWaitPayOrders[i].orderNo === order.orderNo) {
              index1 = i
              break
            }
          }
          if (index1 >= 0) {
            this.displayWaitPayOrders.splice(index1, 1, order)
          }
        } else if (order.status >= EMKT.ORDER_STATUS_PAIED && order.status <= 8) {
          // 执行中订单
          for (let i = 0; i < myOrders.executedOrderList.length; i++) {
            if (myOrders.executedOrderList[i].orderNo === order.orderNo) {
              index = i
              break
            }
          }
          if (index >= 0) {
            myOrders.executedOrderList.splice(index, 1, order)
          }
          for (let i = 0; i < this.displayExecutedOrders.length; i++) {
            if (this.displayExecutedOrders[i].orderNo === order.orderNo) {
              index1 = i
              break
            }
          }
          if (index1 >= 0) {
            this.displayExecutedOrders.splice(index1, 1, order)
          }
        } else if (this.orderDetail.status >= 8 && this.orderDetail.status <= EMKT.ORDER_STATUS_FINISHED) {
          // 已完成订单
          for (let i = 0; i < myOrders.finishedOrderList.length; i++) {
            if (myOrders.finishedOrderList[i].orderNo === order.orderNo) {
              index = i
              break
            }
          }
          if (index >= 0) {
            myOrders.finishedOrderList.splice(index, 1, order)
          }
          for (let i = 0; i < this.displayFinishedOrders.length; i++) {
            if (this.displayFinishedOrders[i].orderNo === order.orderNo) {
              index1 = i
              break
            }
          }
          if (index1 >= 0) {
            this.displayFinishedOrders.splice(index1, 1, order)
          }
        }
        this.UPDATE_WEAPP_MYORDERS(myOrders)
        console.log('updateMyOrders weappMyOrders finish', this.weappMyOrders)
      },
      updateMyOrders (order) {
        let myOrders = this.weappMyOrders
        let index
        let index2
        // 待提交订单
        if (order.status === EMKT.ORDER_STATUS_SUBMITTED ||
            order.status === EMKT.ORDER_STATUS_CHECK ||
            order.status === EMKT.ORDER_STATUS_WAIT_PD_TECH_AUDIT ||
            order.status === EMKT.ORDER_STATUS_SIGN_NEED) {
          myOrders.waitPayOrderList.some((item, i) => {
            if (item.id === order.id) {
              index = i
              return true
            }
          })
          if (index >= 0) {
            myOrders.waitPayOrderList.splice(index, 1)
          }
          this.displayWaitPayOrders.some((item, i) => {
            if (item.id === order.id) {
              index2 = i
              return true
            }
          })
          if (index2 >= 0) {
            this.displayWaitPayOrders.splice(index, 1)
          }
          console.log(index, index2, myOrders, myOrders.waitPayOrderList, order, this.displayWaitPayOrders)
        } else if (order.status === EMKT.ORDER_STATUS_PAIED) {
          // 执行中订单
          myOrders.executedOrderList.some((item, i) => {
            if (item.id === order.id) {
              index = i
              return true
            }
          })
          if (index >= 0) {
            myOrders.executedOrderList.splice(index, 1)
          }
          this.displayExecutedOrders.some((item, i) => {
            if (item.id === order.id) {
              index2 = i
              return true
            }
          })
          index2 = this.displayExecutedOrders.indexOf(order)
          if (index2 >= 0) {
            this.displayExecutedOrders.splice(index, 1)
          }
        }
        order.status = EMKT.ORDER_STATUS_ABORT
        myOrders.cancledOrderList.unshift(order)
        this.displayCancledOrders.unshift(order)
        this.UPDATE_WEAPP_MYORDERS(myOrders)
        console.log('updateMyOrders weappMyOrders finish', myOrders, this.weappMyOrders)
      },
      handleOrderCancel (order) {
        this.$weui.dialog({
          title: '当订单未提交或未开始生产时，您随时可以取消订单，是否确认取消？',
          buttons: [{
            label: '否',
            type: 'default',
            onClick: () => {
              return
            }
          }, {
            label: '是',
            type: 'primary',
            onClick: () => {
              this.cancelOrder(order)
            }
          }]
        })
      },
      handleOrderToCheckSignApprove (bOrder) {
        this.$weui.loading('加载中')
        this.gcapi('checkOrderSignAndApprove', [{id: bOrder.id}]).then(response => {
          if (response && response.body.result && response.body.code === 0) {
            this.$weui.loading('加载中').hide()
            let order = response.body.result[0]
            if (order.status === EMKT.ORDER_STATUS_ABORT) {
              alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单')
              if (EMKT.isWapp) {
                wx.miniProgram.switchTab({ url: '/pages/cart/cart' })
              } else {
                this.$router.replace({ name: 'cart' })
              }
            } else if (order.status === EMKT.ORDER_STATUS_CHECK || order.status === EMKT.ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === EMKT.ORDER_STATUS_SUBMITTED) {
              this.$router.replace({ name: 'submitSuccess', query: { info: true, orderStatus: order.status } })
            } else if (order.status === EMKT.ORDER_STATUS_SIGN_NEED) {
              this.$router.replace({ name: 'promotions', query: { orderId: order.id, cc: true } })
            } else if (order.status === EMKT.ORDER_STATUS_PAIED) {
              this.$router.replace({ name: 'WeappSuccessPay', params: { orderId: order.id } })
            } else if (order.status === EMKT.ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE) {
              this.$weui.topTips('提交订单失败，请联系客服或重新提交订单')
            }
          }
        })
      },
      handleOrderSubmit (order) {
        this.$weui.loading('加载中')
        console.log('handleOrderSubmit', order, 'leaveOrderListPosition', document.getElementById('myOrderList').scrollTop)
        EMKT.setStoreItem('leaveOrderListPosition', document.getElementById('myOrderList').scrollTop)
        this.gcapi('getWaitPayOrderInfoByOrderId', order.id).then(res => {
          if (res && res.body.result) {
            const waitPayOrder = res.body.result
            this.SET_CURRENT_WAITPAY_ORDER(waitPayOrder)
            this.$weui.loading('加载中').hide()
            this.$router.push({name: 'WeappOrderConfirmation'})
          }
        })
      },
      handleOrderToSign (order) {
        console.log('handleOrderSubmit', order, 'leaveOrderListPosition', document.getElementById('myOrderList').scrollTop)
        EMKT.setStoreItem('leaveOrderListPosition', document.getElementById('myOrderList').scrollTop)
        this.$router.push({name: 'promotions', query: {orderId: order.id, cc: true}})
      }
    }
  }
</script>

<style scoped>
  .order-container {
    overflow-y:scroll;
    overflow-x:hidden;
    /*-webkit-overflow-scrolling:touch;*/
    height:100vh;
    padding: 10px;
    background-color: #FAFAFA;
  }




  .box {
    display: flex;
    flex-shrink: 0;
    position: fixed;
    align-items: center;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100%;
    top: 90px;
    left: 0;
    padding: 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 40px);
  }


  .bd {
    position: fixed;
    top: 0px;
    left: 0;
    width:100%;
    /*height:95px;*/
    background:rgba(255,255,255,1);
    /*border-radius:10px;*/
    /*border:1px solid rgba(239,238,243,1);*/
  }

  .tab-group {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: 40px;
  }
  .tab-line-group {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 95%;
    height: 2px;
    margin: 0 auto;
  }
  .under-line {
    margin-top: -2px;
    border-top-width: 2px;
    border-top-style: solid;
    border-top-color: rgba(88, 120, 250, 1);
    width: 56px;
    height: 1px;
  }
  .order-list {
    /*margin-top: 10px;*/
    width: 100%;
  }

  .order-status {
    line-height: 49px;
    white-space: nowrap;
    color: #979797;
    font-size: 14px;
    font-weight: 400;
  }

</style>



// WEBPACK FOOTER //
// Orders.vue?639e9196